/**
 * Show/hide toggle for server-rendered password fields (login, reset password).
 *
 * React inputs handle their own toggle in core/components/Input.tsx.
 * Uses event delegation on `document` so it survives Turbolinks navigations
 * and only needs to be wired once.
 */

const XLINK_NS = "http://www.w3.org/1999/xlink";

function setIcon(useEl: SVGUseElement, name: string): void {
  useEl.setAttribute("href", `#${name}`);
  useEl.setAttributeNS(XLINK_NS, "xlink:href", `#${name}`);
}

export function initPasswordToggles(): void {
  document.addEventListener("click", (event) => {
    const target = event.target as HTMLElement | null;
    const toggle = target?.closest<HTMLButtonElement>(".js-password-toggle");
    if (!toggle) return;

    const input = toggle.closest(".field-container")?.querySelector<HTMLInputElement>("input");
    if (!input) return;

    const reveal = input.type === "password";
    input.type = reveal ? "text" : "password";
    toggle.setAttribute("aria-label", reveal ? "Hide password" : "Show password");

    const useEl = toggle.querySelector<SVGUseElement>("use");
    if (useEl) setIcon(useEl, reveal ? "eye-slash" : "eye");
  });
}
